import { Container, Row, Col, Card, Button } from "react-bootstrap";
import NavigationBar from "../components/navigationbar";
import Footer from "../components/footer";
import nuecesbanner from "../assets/nuecesbanner.png";
import imamanwar from "../assets/imamanwar.jpg";
import nueces1 from "../assets/nueces1.jpg";

const Nueces = () => {
    return (
        <div className="position-relative">
            <NavigationBar />

            {/* Hero Banner */}
            <div
                style={{
                    backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.6) 0%, rgba(64,64,64,0) 50%), url(${nuecesbanner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center 70%",
                    textAlign: "left",
                    height: "40vh",
                    paddingTop: "20px",
                }}
            >
                <div
                    style={{
                        maxWidth: "1200px",
                        margin: "0 auto",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <h4
                        style={{
                            fontSize: "14px",
                            textAlign: "center",
                            marginBottom: "30px",
                            color: "white",
                            textShadow: "1px 1px 2px black",
                        }}
                    >
                        Greater Austin Muslim Relief Committee
                    </h4>
                    <div style={{ maxWidth: "700px" }}>
                        <h1
                            style={{
                                fontSize: "36px",
                                marginBottom: "10px",
                                color: "white",
                                textShadow: "1px 1px 2px black",
                            }}
                        >
                            Nueces Mosque Reconstruction
                        </h1>
                        <p
                            style={{
                                fontSize: "24px",
                                lineHeight: "1.4",
                                paddingRight: "250px",
                                color: "white",
                                textShadow: "1px 1px 2px black",
                            }}
                        >
                            Help us build a home for the next generation of Muslims. What
                            starts here, changes the Ummah.
                        </p>
                        <Button
                            href="https://www.nuecesmosque.com/reconstruction"
                            className=" px-4 py-1 pt-2 text-center align-items-center"
                            target=""
                            style={{
                                backgroundColor: "#b65f0fff",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                            }}
                        >
                            <h2>Donate Now</h2>
                        </Button>
                    </div>
                </div>
            </div>

            <Container className="my-5">
                {/* Legacy */}
                <Row className="text-center mt-4">
                    <h2>A Legacy of Faith and Community</h2>
                </Row>
                <Row className="justify-content-center my-2">
                    <Col md={10} className="text-center">
                        <p>
                            For more than 45 years, Nueces Mosque has been a home for
                            Muslim students in Austin. From daily prayers, social gatherings and Ramadan iftars,
                            this small yellow house has nurtured generations of leaders,
                            scholars, and community members. Now, as our community grows, it’s
                            time to build a space that will carry this legacy into the future.
                        </p>
                    </Col>
                </Row>

                <hr className="my-5" />

                {/* Why Nueces Matters */}
                <Row className="align-items-center my-5">
                    <Col md={6}>
                        <h3 className="mb-4">Why Nueces Matters</h3>
                        <p>
                            University is a pivotal time in a young Muslim’s life. At Nueces,
                            students reconnect with Islam, often for the first time, in
                            community. It is where identities are shaped, friendships are
                            formed, and future leaders are nurtured.
                        </p>
                        <blockquote className="blockquote">
                            <em>
                                “At Nueces Mosque, we see hundreds of students walk through these doors
                                every year and transform into the best versions of themselves — the best Muslims they can be.”
                            </em>
                            <footer className="blockquote-footer mt-2">Imam Anwar</footer>
                        </blockquote>
                    </Col>
                    <Col className="text-center">
                        <img
                            src={imamanwar}
                            alt="Imam Anwar at Nueces"
                            className="img-fluid rounded shadow mx-2"
                            style={{ maxHeight: "300px" }}
                        />
                        <img
                            src={nueces1}
                            alt="Students at Nueces"
                            className="img-fluid rounded shadow"
                            style={{ maxHeight: "300px" }}
                        />
                    </Col>
                </Row>
                <hr className="my-5" />

                {/* Why YOU Should Care */}
                <Row className="justify-content-center my-5">
                    <Col md={12}>
                        <h2 className="mb-4 text-start">Why Should YOU Care About Nueces?</h2>
                        <p className="text-start">
                            This project is bigger than one campus, one city, or even one generation.
                            The students who walk through these doors today will be tomorrow’s lawyers,
                            doctors, educators, community organizers, and leaders. What they learn here,
                            they will carry with them to every corner of the world.
                        </p>

                        <ul className="text-start">
                            <li style={{ fontSize: "1.1rem", marginBottom: "1rem" }}>
                                <strong>A Legacy Beyond Students:</strong> Whether you’re an alum, a parent,
                                a resident of Austin, or simply someone who believes in strengthening the Ummah,
                                Nueces belongs to you. Its impact goes far beyond UT Austin, shaping Muslim
                                identity and leadership across the nation.
                            </li>
                            <li style={{ fontSize: "1.1rem", marginBottom: "1rem" }}>
                                <strong>A Place of Humanitarian Service:</strong> Nueces isn’t just about
                                prayers and lectures. Students and community members actively volunteer,
                                organize drives, and serve the Greater Austin community, making the
                                mosque a place of compassion and service.
                            </li>
                            <li style={{ fontSize: "1.1rem", marginBottom: "1rem" }}>
                                <strong>Every Act Counts:</strong> Every plate served, every class taught,
                                and every prayer made at Nueces is part of a legacy you can share in.
                                Together, we can build a space where future generations will thrive.
                            </li>
                        </ul>

                        <blockquote className="blockquote text-start mt-4">
                            <em>
                                "This is a community like no other in America. A place where the world’s brightest
                                students come to connect with Islam, gain knowledge, and return home as trained leaders."

                            </em>
                            <footer className="blockquote-footer mt-2">Imam Jawad Rasul</footer>
                        </blockquote>
                    </Col>
                </Row>


                <hr className="my-5" />

                {/* Stats */}
                <Row className="text-center my-5">
                    <Col md={4}>
                        <Card className="h-100 border-success shadow-sm">
                            <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                <h2 style={{ color: "#2d4724", fontWeight: "bold" }}>500+</h2>
                                <p>Iftars served every night during Ramadan</p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4}>
                        <Card className="h-100 border-success shadow-sm">
                            <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                <h2 style={{ color: "#2d4724", fontWeight: "bold" }}>45+</h2>
                                <p>Years of service to Muslim students and the Austin community</p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4}>
                        <Card className="h-100 border-success shadow-sm">
                            <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                <h2 style={{ color: "#2d4724", fontWeight: "bold" }}>1st</h2>
                                <p>The largest fully student run mosque in the United States</p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <hr className="my-5" />

                {/* Vision Section */}
                <Row className="align-items-center my-5 justify-content-between">
                    <Col md={5}>
                        <h3>The Vision for Tomorrow</h3>
                        <p>
                            The new Nueces will be more than a mosque. It will be a hub for
                            students to pray, learn, and grow. With housing, classrooms, study
                            spaces, and lounges, it will be a sanctuary built by students, for
                            students — ensuring every young Muslim has a safe space to thrive
                            spiritually, intellectually, and socially.
                        </p>
                    </Col>
                    <Col md={6} className="text-center">
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/R38-NwVUBjk?si=xN_kh2QiFBHvorDd" 
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        ></iframe>

                    </Col>

                </Row>

                <hr className="my-5" />
                {/*Mufti Umer Esmail */}
                {/* Mufti Umer Esmail */}
                <Row className="text-center my-5 align-items-center justify-content-between">
                    <Col md={5}>
                        <img
                            src="https://s.hdnux.com/photos/01/52/37/31/27915882/6/ratio4x3_960.webp"
                            alt="Mufti Mohamed-Umer Esmail"
                            className="img-fluid rounded"
                        />
                    </Col>
                    <Col md={6} className="d-flex flex-column justify-content-center">
                        <h4>Honoring Mufti Umer Esmail (Rahimahullah)</h4>
                        <p>
                            Mufti Umer Esmail was a beloved scholar and imam whose guidance profoundly shaped the UT and Austin Muslim community.
                            Serving Nueces Mosque for nearly a decade, he touched the lives of countless students, helping them grow spiritually, intellectually, and personally.
                            Known for his humility, compassion, and dedication to both family and community, he embodied the Prophetic example of service to Allah and His creation.
                        </p>
                        <p>
                            Though he passed in 2019, his legacy lives on in the students he mentored, the community he nurtured, and the vision for Nueces Mosque that continues to inspire us today.
                            Naming the new center in his honor is a tribute to his lifetime of service and enduring impact.
                        </p>
                        <h5>
                            Honor Mufti Umer’s legacy by helping continue the work he devoted his life to.
                        </h5>
                    </Col>
                </Row>

                <hr className="my-5" />

                {/* Call to Action */}
                <Row className="text-center my-5">
                    <Col>
                        <h2>Be Part of Building the Future</h2>
                        <p>
                            Support the Nueces Mosque Reconstruction Project. Every dollar you
                            give is an investment in the next generation of Muslims. Together,
                            we can create a space that will serve students and the Ummah for
                            generations to come. <br />
                            <em>
                                “Whoever builds a Masjid for Allah, Allah will build a home for
                                them in paradise” (Sahih Muslim)
                            </em>
                        </p>
                    </Col>
                    <Col className="text-center">
                        <p>
                            Donate now through Stocks, Zelle, Venmo, Company Matching, Checks, Feeling Blessed, or if you are not ready to donate yet, pledge your support!
                        </p>
                        <Button
                            href="https://www.nuecesmosque.com/reconstruction#donate"
                            className=" px-4 py-1 pt-2 text-center align-items-center"
                            style={{
                                backgroundColor: "#975c17ff",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                            }}
                        >
                            <h3>Donate Now</h3>
                        </Button>
                    </Col>
                </Row>
            </Container>

            <Footer />
        </div>
    );
};

export default Nueces;
